import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, model } from '@angular/core';

export interface ChecklistItem {
    seccion: string;
    pregunta: string;
    preguntaId?: string; // UUID
    preguntaIdVisible?: number; // legacy numeric id
    respuesta?: 'OK' | 'REP' | 'NA';
    comentario?: string;
}

@Component({
    selector: 'app-checklist',
    templateUrl: './checklist.component.html',
    styleUrl: './checklist.component.scss',
    standalone: false
})
export class ChecklistComponent implements OnChanges {
    @Input() titulo: string = 'Checklist';
    @Input() subtitle?: string;
    @Input() readOnly: boolean = false;
    @Input() commentPlaceholder: string = 'Si requiere escribir algún comentario.';
    items = model<ChecklistItem[]>([]);

    @Output() completar = new EventEmitter<void>();

    setRespuesta(index: number, valor: 'OK' | 'REP' | 'NA') {
        if (this.readOnly) return;
        if (!this.items() || !this.items()[index]) return;
        this.items()[index].respuesta = valor;
    }

    ngOnChanges(changes: SimpleChanges) {
        // Cuando los items cambian (llegan desde el padre), asegurar que la respuesta por defecto sea 'NA'
        if (changes['items'] && Array.isArray(this.items())) {
            this.items().forEach((item) => {
                if (!item.respuesta) item.respuesta = 'NA';
            });
        }
    }

    completarChecklist() {
        // (podés validar que estén todos respondidos si querés)
        this.completar.emit();
    }
}
